
// 检测 email
export function isEmail(value: string) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(value)
}

// 检测手机号码
export function isMobile(value: string) {
  return /^1[0-9]{10}$/.test(value)
}

// 检测电话号码
export function isPhone(value: string) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(value)
}
